<template>
	<div id="wrapper" class="mb-5 bg-white h-100vh scrollbar">
	    <div class="container">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-7">
	                <div class="customFotm pt-4">
	                    <div class="imgcontainer text-center mb-4">
	                        <img src="../../../../static/website/images/logo.svg" alt="Logo" class="avatar">
	                    </div>
	                    <div class="loginElement mb-4">
	                    	<loader v-if="pageLoader"></loader>
	                        <h3 class="text-center yellowColor mb-4">Welcome to <span class="themecolor">Client</span> Portal</h3>
	                        <div class="row">
	                            <div class="col-12 col-lg-6">
	                                <div class="form-group inputIcon">
	                                    <label for="uname">First Name</label>
	                                    <div class="position-relative">
	                                        <input type="text" placeholder=" " name="Fname" class="form-control" v-model="Fname" v-validate="'required'" maxlength="20">
	                                        <span class="iconInput"><feather type="user"></feather></span>
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('Fname')">{{ errors.first('Fname').replace('Fname','First name') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-12 col-lg-6">
	                                <div class="form-group inputIcon">
	                                    <label for="uname">Last Name</label>
	                                    <div class="position-relative">
	                                        <input type="text" placeholder=" " name="Lname" class="form-control" v-model="Lname" v-validate="'required'" maxlength="20">
	                                        <span class="iconInput"><feather type="user"></feather></span>
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('Lname')">{{ errors.first('Lname').replace('Lname','Last name') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-12">
	                                <div class="form-group">
	                                    <label for="uname">Email Address</label>
	                                    <div class="position-relative inputIcon">
	                                        <input type="email" placeholder="" name="email" v-model="email" class="form-control" v-validate="'email'"><!-- required| -->
	                                        <span class="iconInput"><feather type="mail"></feather></span>
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-12">
	                                <div class="form-group">
	                                    <label for="uname">Password</label>
	                                    <div class="position-relative inputIcon">
	                                        <input :type="showPass?'text':'password'" placeholder=" " name="password" v-model="password" class="form-control pr-5" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,24}$/}">
			                                <span class="iconInput" v-if="!showPass" @click="showPass = !showPass"><feather type="eye-off"></feather></span>
			                                <span class="iconInput" v-else-if="showPass" @click="showPass = !showPass"><feather type="eye"></feather></span>
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('password')">{{ errors.first('password') }}</span>
	                                </div>
	                            </div>
	                            <!-- <div class="col-12 col-lg-6">
	                                <div class="form-group">
                                   		<label for="username">Country</label>
	                                    <v-select :clearable="false" :options="residence_country" :reduce="name => name.iso2" label="name" v-model="res_country"  v-validate="'required'" name="res_country"  :class="((res_country != '')?'active' :'') || ({ 'is-invalid': submitted && errors.has('res_country') })" class="customflaotField form-control"  />
	                                    	<div class="text-danger" v-if="submitted && errors.has('res_country')">{{ errors.first('res_country').replace('res_country','Country') }}</div>
	                                </div>
	                            </div> -->
	                            <div class="col-12">
	                                <div class="form-group">
	                                    <label for="uname">Phone Number</label>
	                                    <div class="position-relative inputIcon">
	                                        <input type="text" placeholder=" " name="number" v-model="number" class="form-control pr-5" v-validate="'required|numeric|min:10'">
	                                        <span class="iconInput"><feather type="phone"></feather></span>
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('number')">{{ errors.first('number') }}</span>
	                                </div>
	                            </div>
	                            <div class="col-12" v-if="diseaseList.length > 0">
									<p>What do you need help with?</p>
	                            	<div class="form-group d-flex flex-wrap needHelp">
			                            <label class="checkbox" v-for="item,key in diseaseList" :for="'medical_'+key">{{item.name}}
			                                <input type="checkbox" :id="'medical_'+key" :value="parseInt(item.id)" v-model="medical" name="medical" v-validate="'required'">
			                                <span class="checkmark"></span>
			                            </label>
	                                    <span class="text-danger" v-if="submitted && errors.has('medical')">Field is required</span>
			                        </div>
			                        <div class="form-group" v-if="medical.includes(151)">
	                                    <!-- <label for="uname">Phone Number</label> -->
	                                    <div class="position-relative inputIcon">
	                                        <input type="text" placeholder="Others..." name="other_condition" v-model="other_condition" class="form-control pr-5" v-validate="'required'">
	                                    </div>
	                                    <span class="text-danger" v-if="submitted && errors.has('other_condition')">field is required</span>
	                                </div>
	                            </div>
	                            <div class="col-12">
	                                <div class="form-group mt-4">
	                                    <button class="btn btn-link btn-blue w-100"  @click.stop.prevent="submit()">Register</button>
	                                </div>
	                            </div>
	                            <div class="col-12">
	                                <div class="form-group mb-0 text-center mt-1">
	                                    <p class="mb-0">Back to <router-link to="/">login</router-link></p>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	// var CryptoJS = require("crypto-js"); 
	// const crypto = require('crypto');
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	// import TwoFa from '../security/security'
	export default {
		name: 'App-register',
		data() {
			return {
				pageLoader: false,
                notification_msg:'',
                notification_type:'',
				submitted: false,
				Fname: '',
				Lname: '',
				email: '',
				password: '',
				res_country: '',
				number: '',
				showPass: false,
				other_condition: '',
				
				code : '',
				submittedCode : false,
				gAuthenticatorEnabled : '0',
				faFlag : false,
				medical:[],
			}
		},
		watch:{
			number(val){
				this.number = val.toString()
                .replace(/[^\d]/g, '')  
			}
		},
		components: {
			// appTwofa : TwoFa
		},
		methods: {
			...mapActions({
				_runUserSignUp: types.RUN_USER_SIGNUP
			}),
			submit() {
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json = {
							'globalParams': {
								"fname": _that.Fname,
								"lname" : _that.Lname,
								"email": _that.email || _that.number,
								"password": _that.password,
								"mobile_no": _that.number,
								"medical": _that.medical,
							},
							'localParams': {
								"parameter": _that
							}
						}
						if(_that.medical.includes(151)){
							input_json.globalParams.other_condition = _that.other_condition
						}
						_that._runUserSignUp(input_json)
					}
				})
			}
		},
		created(){
			this._rungetRegisterDiseaseList({'globalParams': {},'localParams': {"parameter": this}})
		}
	}
</script>
<style>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	  margin: 0;
	}

	/* Firefox */
	input[type=number] {
	  -moz-appearance: textfield;
	}
</style>


// WEBPACK FOOTER //
// src/components/website/user/register.vue